import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <div>
    <SimpleTable style={{ marginBottom: '10px' }}>
      <div>
        <div>Recipient:</div>
        <div>{node.extras.recipient}</div>
      </div>
    </SimpleTable>
    {node.extras.message}
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendEmail/SendEmailDisplay.jsx